import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { Provider } from "react-redux";
import store from "@frameworks/web/redux/store";
import Index from "./components/Index";
import MobBottomClick from "./components/header/MobileBottomClick";
import "bootstrap/dist/css/bootstrap.min.css";
import HoldingPositionReport from "./components/Reports/HoldingReports/Desktop/HoldingPositionReport";
import HoldingPositionMobileReport from "./components/Reports/HoldingReports/Mobile/HoldingPositionMobileReport";
import HoldingReportFormMob from "./components/Reports/HoldingReports/dowloadHoldingReport/dowloadHoldingReportsMob/HoldingReportFormMob";
import DeviceContext from "./utils/indentifyDevice";
import DPtransactionFormMob from "./components/Reports/HoldingReports/dowloadHoldingReport/DPtransactionFormDesk/DPtransactionFormMob";
import PnlViewTransactionReport from "./components/Reports/PNLReports/PnlViewTransactionReport";
// import HoldingReportFormMob from "./components/Reports/HoldingReports/dowloadHoldingReport/dowloadHoldingReportsMob/HoldingReportFormMob";
// import HoldingDrawerContent from "./components/Reports/HoldingReports/HoldingReportsComponent/Drawer/HoldingDrawerContent";
// import HoldingReportFormDesk from "./components/Reports/HoldingReports/dowloadHoldingReport/dowloadHoldingReportsDesk/holdingReportsFromDesk";
import DownloadReportPopupMob from "./components/Reports/PNLReports/Mobile/DownloadReportPNLMob";
import TaxDownloadPopupMob from "./components/Reports/TaxReports/TaxDownloadPopupMob";
import Div100vh from "react-div-100vh";
import config from "@frameworks/web/config/domain";
import "./stylesheets/components/generic/generic.scss";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { WebConfig } from "@frameworks/web/utils/webConfig";
import { ParamsProvider } from "@frameworks/web/components/generic/customHooks/ParamsContext";
import SwitchToEnhancedReports from "@frameworks/web/components/Reports/SwitchToEnhancedReports";
import { useCacheInvalidate } from "@frameworks/web/utils/useCacheInvalidate";
const GlobalStyle = createGlobalStyle `
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4 {
    letter-spacing: 0.3px;
  }
`;
const IframeStyle = createGlobalStyle `
body {
  overflow-y: scroll;
}
body::-webkit-scrollbar {
  width: 5px;
}
body::-webkit-scrollbar-track {
  width: 5px;
}
body::-webkit-scrollbar-thumb {
  width: 5px;
  border-radius:2px;
  background-color: #b8b8b8;
}
`;
export const ReportScrollBehaviour = createGlobalStyle `
html{
  scroll-behavior: auto !important;
}
`;
const App = () => {
    const { loginOrigin } = useParams();
    useCacheInvalidate({
        checkInterval: 1000 * 60 * 60 * 24,
        maxRetries: 3,
    });
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [operation, setOperation] = React.useState();
    const wrapper = (React.createElement(BrowserRouter, { basename: process.env.PUBLIC_URL },
        React.createElement(Provider, { store: store },
            React.createElement(WebConfig, null,
                React.createElement(ParamsProvider, null,
                    React.createElement(Routes, null,
                        React.createElement(Route, { path: "/*", element: React.createElement(Index, null) }),
                        React.createElement(Route, { path: "/MobMenu", element: React.createElement(MobBottomClick, null) }),
                        React.createElement(Route, { path: "/showholdingReportFormMob", element: React.createElement(HoldingReportFormMob, { setDownloadSuccess: setDownloadSuccess, setShowLoader: setShowLoader, setDownloadFail: setDownloadFail, showLoader: showLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, setOperation: setOperation, operation: operation }) }),
                        React.createElement(Route, { path: "/showDPTransactionFormMob", element: React.createElement(DPtransactionFormMob, null) }),
                        React.createElement(Route, { path: config.feReportBase, element: React.createElement(React.Fragment, null,
                                React.createElement(SwitchToEnhancedReports, null),
                                DeviceContext().isDesktop ? (React.createElement(React.Fragment, null,
                                    React.createElement(ReportScrollBehaviour, null),
                                    React.createElement(HoldingPositionReport, null))) : (React.createElement(HoldingPositionMobileReport, null))) }),
                        React.createElement(Route, { path: config.feReportBase + "/:loginOrigin", element: DeviceContext().isDesktop ? (React.createElement(HoldingPositionReport, null)) : (React.createElement(HoldingPositionMobileReport, null)) }),
                        React.createElement(Route, { path: "/view-pnl-transaction-report", element: React.createElement(PnlViewTransactionReport, null) }),
                        React.createElement(Route, { path: "/pnlDownload", element: React.createElement(DownloadReportPopupMob, { setDownloadSuccess: setDownloadSuccess, setShowLoader: setShowLoader, setDownloadFail: setDownloadFail, showLoader: showLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, setOperation: setOperation, operation: operation }) }),
                        React.createElement(Route, { path: "/taxDownload", element: React.createElement(TaxDownloadPopupMob, { setDownloadSuccess: setDownloadSuccess, setShowLoader: setShowLoader, setDownloadFail: setDownloadFail, showLoader: showLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, setOperation: setOperation, operation: operation }) })))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, null),
        DeviceContext().isDesktop ? (React.createElement(React.Fragment, null,
            loginOrigin === LoginSource.SALES && React.createElement(IframeStyle, null),
            wrapper)) : (React.createElement(Div100vh, null, wrapper))));
};
ReactDOM.render(React.createElement(App, null), document.getElementById("app"));
